import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { checkIsAdmin } from '../helpers/checkisAdmin';  // Asegúrate de que la ruta es correcta

export const useCheckIsAdmin = () => {
  const [isAdmin, setisAdmin] = useState(false);
  const [isCheckingRole, setIsCheckingRole] = useState(true);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    const verifyRole = async () => {
      setIsCheckingRole(true);  // Establecer que está verificando el rol
      const token = Cookies.get("token");
      if (!token) {
        setError("No token found");
        setIsCheckingRole(false);  // Actualizar el estado a no verificando
        return;  // Salir temprano si no hay token
      }
      try {
        const isAdminCheck = await checkIsAdmin(token);
        setisAdmin(isAdminCheck);  // Establecer si tiene el rol
      } catch (err: any) {
        setError(err.message || 'An error occurred');  // Establecer el mensaje de error
      } finally {
        setIsCheckingRole(false);  // Finalizar la verificación del rol
      }
    };

    verifyRole();
  }, []);  // Dependencias del useEffect

  return { isAdmin, isCheckingRole, error };
}
